<div *ngIf="mediaObject.type === MediaTypeEnum.IMAGE"
     [appAspectRatio]="ratio"
     [id]="id || mediaObject.id"
     [style.aspect-ratio]="cssAspectRatio"
     [class.media-view-container--backdrop]="showBackdrop && !isInLightBoxContext && !!backdropUrl"
  class="relative media-view-container gallery-image-container"
>
  <ng-container *ngIf="backdropUrl as backdrop">
    <img *ngIf="(backdrop | offlineMedia:'image' | async) as backdropSrc"
         class="media-view-backdrop"
         [src]="backdropSrc"
         decoding="async"
         (error)="onBackdropError(backdrop)"
         alt=""
         aria-hidden="true">
  </ng-container>
  <div *ngIf="deferLoading || !imageLoaded" class="media-view-placeholder"></div>
  <ng-container *ngIf="!deferLoading && thumbnailOnly; else cachedImage">
    <img alt="picture"
         id="{{prefix}}-{{id || mediaObject.id}}"
         class="media-view-image"
         [style]="contain ? 'object-fit: contain !important' : ''"
         [src]="getImageThumbnail()"
         [attr.loading]="getThumbnailLoadingMode()"
         decoding="async"
         [style.visibility]="imageLoaded ? 'visible' : 'hidden'"
         (load)="onImageLoaded()">
  </ng-container>
  <ng-template #cachedImage>
  <ng-container *ngIf="!deferLoading && ((mediaObject | mediaObject: {formatType: 'thumb_md', defaultImageType: 'background'}) | offlineMedia:'image' | async) as imageSrc">
    <img *ngIf="shouldUseNativeSrc(imageSrc); else optimizedImage"
         alt="picture"
         id="{{prefix}}-{{id || mediaObject.id}}"
         class="media-view-image"
         [style]="contain ? 'object-fit: contain !important' : ''"
         [src]="imageSrc || ''"
         [style.visibility]="imageLoaded ? 'visible' : 'hidden'"
         (load)="onImageLoaded()">
    <ng-template #optimizedImage>
      <img alt="picture"
           id="{{prefix}}-{{id || mediaObject.id}}"
           class="media-view-image"
           [style]="contain ? 'object-fit: contain !important' : ''"
           [ngSrc]="imageSrc || ''"
           [style.visibility]="imageLoaded ? 'visible' : 'hidden'"
           [fill]="true"
           [priority]="priority"
           (load)="onImageLoaded()">
    </ng-template>
  </ng-container>
  </ng-template>
</div>
<div [id]="id || mediaObject.id" class="relative media-view-container gallery-video-container"
     [class.media-view-container--backdrop]="showBackdrop && !isInLightBoxContext && !!backdropUrl"
     *ngIf="mediaObject.type === MediaTypeEnum.VIDEO">
  <ng-container *ngIf="backdropUrl as backdrop">
    <img *ngIf="(backdrop | offlineMedia:'image' | async) as backdropSrc"
         class="media-view-backdrop"
         [src]="backdropSrc"
         decoding="async"
         (error)="onBackdropError(backdrop)"
         alt=""
         aria-hidden="true">
  </ng-container>
  <ng-container *ngIf="!deferLoading && thumbnailOnly; else videoPlayer">
    <div *ngIf="!imageLoaded" class="media-view-placeholder"></div>
    <img alt="video poster"
         class="media-view-image"
         [src]="getVideoPoster()"
         [attr.loading]="getThumbnailLoadingMode()"
         decoding="async"
         [style.visibility]="imageLoaded ? 'visible' : 'hidden'"
         (load)="onImageLoaded()">
  </ng-container>
  <ng-template #videoPlayer>
  <div *ngIf="!isInLightBoxContext && (deferLoading || !hasPlayableVideoSource())" class="media-view-placeholder"></div>
  <ng-container *ngIf="!deferLoading">
  <video
    [attr.preload]="videoDecoderMode === 'warm' ? 'auto' : 'metadata'"
    id="{{prefix}}-{{id || mediaObject.id}}"
    class="timeline-player"
    width="100%"
    crossorigin
    muted="muted"
    playsinline
    [poster]="hasPlayableVideoSource() ? (((getVideoPoster()) | offlineMedia:'image' | async) || '') : ''"
  >
    <!--    <source [src]="mediaObject | mediaObject:{formatType: 'original'}" type="{{mediaObject.mimeType}}">-->
  </video>
  <div *ngIf="!isInLightBoxContext && (videoService.muted$ | async) !== null" class="absolute volume">
    <button (click)="toggleVolume($event)" pButton pRipple *ngIf="videoService.muted$ | async" icon="fa fa-volume-high"
            class="p-button-rounded p-button-default p-button-text"></button>
    <button (click)="toggleVolume($event)" pButton pRipple *ngIf="!(videoService.muted$ | async)" icon="fa fa-volume-xmark"
            class="p-button-rounded p-button-default p-button-text"></button>
  </div>
  <div *ngIf="isEnded" class="absolute end-credits">
    <button pButton pRipple type="button" label="{{'shared.media-view.replay'|translate}}"
            class="p-button-rounded text-white"></button>
  </div>
  </ng-container>
  </ng-template>
</div>
